import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  // Utilisation de BehaviorSubject pour permettre aux composants de réagir à chaque changement
  private searchQuerySource = new BehaviorSubject<string>(''); // Valeur initiale vide
  currentSearchQuery = this.searchQuerySource.asObservable(); // Observable à écouter dans les composants

  constructor() { }

  // Méthode pour mettre à jour le texte de la recherche
  updateSearchQuery(query: string) {
    this.searchQuerySource.next(query);
  }
}
